import {faArrowUp} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button, Input} from 'antd';
import {useCallback, useRef} from 'react';

import {useLocale} from '../../../../../../../provider/locale/locale-hook';
import {AnalyticsTarget, track} from '../../../../../../../service/analytics/analytics';

import * as styles from './ai-chat-input.scss';

type PropsType = {
    onSend: (text: string) => void;
    inputValue: string;
    setInputValue: (value: string) => void;
    disabled?: boolean;
};

export function AiChatInput(props: PropsType): JSX.Element {
    const {onSend, inputValue, setInputValue, disabled} = props;

    const {getLocalizedString} = useLocale();
    const isFirstSend = useRef(true);

    const handleSend = useCallback(() => {
        if (isFirstSend.current) {
            track(AnalyticsTarget.ReviewsAnalysis.AiChat, inputValue);
            isFirstSend.current = false;
        }

        onSend(inputValue);

        setInputValue('');
    }, [inputValue, onSend, setInputValue]);

    return (
        <div className={styles.AiChatInput}>
            <Input.TextArea
                autoSize={{minRows: 1, maxRows: 4}}
                className={styles.AiChatInput_input}
                onChange={(event) => setInputValue(event.target.value)}
                onPressEnter={handleSend}
                placeholder={getLocalizedString('REVIEWS_ANALYSIS__AI_ANALYSIS__PLACEHOLDER')}
                value={inputValue}
                variant="borderless"
            />
            <Button
                className={styles.AiChatInput_button}
                disabled={disabled}
                icon={<FontAwesomeIcon icon={faArrowUp} />}
                onClick={handleSend}
                shape="circle"
                type="primary"
            />
        </div>
    );
}
